type ResolveUploadFirstStateInput = {
  allTimeTotal: number | null;
  allTimeTotalResolved: boolean;
  hasUploadRefresh: boolean;
  showForcedLoadingState: boolean;
};

export const resolveUploadFirstState = ({
  allTimeTotal,
  allTimeTotalResolved,
  hasUploadRefresh,
  showForcedLoadingState,
}: ResolveUploadFirstStateInput): boolean =>
  !hasUploadRefresh && !showForcedLoadingState && allTimeTotalResolved && allTimeTotal === 0;
